<template>
  <div class="Influencers">
    <div class="top">
      <pre class="font30 co00">
                                              FOSHO用户协议
        </pre>
      <pre class="co00">
           1. 协议的订立
        </pre>
      <pre>
                   1.1.   本协议由[aff.foshobrands.com]（下称“平台”）所有者深圳自在必
                            得科技有限公司（下称“公司”）与拟在平台上通过购买平台提供的有关
                            服务的法律实体（下称“客户”）共同缔结。
           
                   1.2.   客户在本平台选购服务过程中，一经勾选“我已仔细阅读并同意协议”并
                            点击按键，即意味着客户同意与本平台签订本协议并自愿受本协议约束。
           
                   1.3.   本协议在发布之后可能根据业务需求进行修订和挑战。客户知晓并同意，
                            平台有权单方更新、调整本协议的内容，如客户不同意接受调整后的本协
                            议内容时，视为本协议终止。
   
                   1.4.   在本协议之外，平台可能根据业务需要与客户在线下订立补充协议或本协
                            议之附件。双方同意，在协议与前述补充协议或附件内容有冲突时，以线
                            下订立的补充协议或附件为准。

                   1.5.   客户根据其自身需求，在平台中挑选的每种具体服务类型中对应的服务条
                            款和条件构成本协议不可分割的一部分，客户就其挑选的具体服务类型付
                            款即表示完全同意其挑选的服务类型所适用的条款和条件。
        </pre>
      <pre class="co00">
           2. 服务内容
        </pre>
      <pre>
                   2.1.   平台通过建立海外红人/联盟客等分销渠道大数据库，以及与海外红人/联
                            盟客的沟通平台，为客户在平台上寻找与自己业务和营销策略相匹配的海
                            外红人/联盟客，并通过沟通平台，促进客户与海外红人/联盟客之间的沟
                            通和合作。
           
                   2.2.   若客户购买专业版或以上版本，通过客户自主授权，平台提供多个联盟平
                            台管理、数据透视等功能。

                   2.3.   平台根据客户的实际具体需求，为客户提供定制化的营销服务方案
                            
                   2.4.   平台不时推出的其他信息服务，具体服务类型以及其所适用的具体与条件
                            请参见平台就该服务的规定。
        </pre>
      <pre class="  co00">
           3. 服务方式
      </pre>
      <pre>
          客户可以在平台中选择相对应服务套餐，并在根据平台指引的付款方式支付
          有关服务费用后，浏览和选取与其业务和营销策略匹配行业、品牌信息等，
          使用平台提供的服务。
          <!-- 具体而言，平台提供如下几类服务套餐：  -->
        </pre>
      <!-- <div class="table">
        <div>模式</div>
        <div>付费周期</div>
        <div>行业数</div>
        <div>品牌数</div>
        <div>收费</div>
      </div>
      <div class="table">
        <div>月刊</div>
        <div>30天</div>
        <div>1</div>
        <div>3</div>
        <div>**元</div>
      </div>
      <div class="table">
        <div>季度订阅</div>
        <div>90天</div>
        <div>3</div>
        <div>9</div>
        <div>**元</div>
      </div>
      <div class="table">
        <div class="co99">年度订阅</div>
        <div>365天</div>
        <div>12</div>
        <div>36</div>
        <div>**元</div>
      </div> -->
      <pre class="co00">
           4. 权利义务
      </pre>
      <pre>
                   4.1. 平台的权利义务

                   4.1.1 平台有权随时就平台中所展示的海外红人/联盟客或其他营销资源的具体
                           情况进行调整，包括但不限于上传新的资源、下线或关闭特定的资源、对
                           特定资源所展示的具体详情进行修改和调整；

                   4.1.2 客户在开始使用有关服务前，平台有权收取与该类服务所对应的服务费用，
                           并有权就服务的类型、标准或费用进行修改和调整。但是，平台修改或调
                           整服务费用的，对修改或调整前已经支付有关服务费用，选购某项服务的
                           客户不发生溯及既往的效力；

                   4.1.3 平台有义务确保获取海外红人/联盟客的数据合法法规，且已经制定了有关
                           红人隐私政策并确保有关数据的安全；

                   4.1.4 平台有义务在客户支付有关服务费用后，在现有技术水平和措施下，确保
                           有关服务不中断和停止；

                   4.1.5 平台有权就有关客户采用骚扰或其他不正当方式或与本协议法律适用国或
                           者海外红人/联盟客所在国法律和风俗相悖的方式与平台内海外红人/联盟
                           客进行沟通的，暂停客户的沟通权限或者禁止客户与该特定海外红人/联盟
                           客沟通；

                   4.1.6 <span class="decro co00">平台在给客户提供服务的过程中，经过平台的技术监测、日常检测以及任</span>     
                          <span class="decro co00">何第三方的举报，发现平台拟提供给客户的信息中有违反中华人民共和国</span>    
                          <span class="decro co00">法律法规或有损害中华人民共和国国家安全、政治安全或丑化、侮辱中华</span>    
                          <span class="decro co00">人民共和国国家尊严或相关内容或信息有违中华人民共和国公序良俗的，</span>    
                          <span class="decro co00">平台有权单方面撤下该内容或信息。</span>   
                          
                   4.2 客户的权利义务
   
                   4.2.1 客户有权在支付有关服务费用后，根据本协议和该服务类型项下对应的权
                            客户有权在支付有关服务费用后，根据本协议和该服务类型项下对应的权
                      
                   4.2.2 客户有义务在使用服务的过程中，采取正当的以及合乎公序良俗的方式
                            与平台内海外红人/联盟客进行沟通，不得在沟通过程中对海外红人/联盟
                            客进行侮辱或骚扰（含性骚扰）；

                   4.2.3 客户一旦与海外红人/联盟客达成合作协议后，应尽力遵守协议的安排和
                            约定，按照协议的内容履行协议中规定的义务；

                   4.2.4 客户在任何时候不得采取爬虫、以及其他技术措施或手段调取或盗取平
                            台的海外红人/联盟客资源信息；
                      
                   4.2.5 客户从平台获取的有关信息仅限于其自身业务使用，未经平台书面同意，
                            不得将该信息与任何第三方进行分享，但是客户将该信息在其关联公司之
                            间分享的除外；

                   4.2.6 客户不得自己或雇佣任何第三方采取爬虫技术，自动定时或不定时地从
                            平台采集任何数据,无论该采集后的数据是自己使用，或者分享至第三方。

                   4.2.7 客户应根据有关国家的数据和隐私保护法律法规的规定对从平台获取的
                            海外红人/联盟客的数据和信息承担保密义务，并同意视情况根据平台的要
                            求与平台签署数据保护协议（DPA）。
      </pre>
      <!-- <pre class=" ">
                    ●     <span class="decro co00">平台有权就有关客户采用骚扰或其他不正当方式或与本协议法律适</span>
                           <span class="decro co00">用国或者海外红人/联盟客所在国法律和风俗相悖的方式与平台内</span>
                           <span class="decro co00">海外红人/联盟客进行沟通的，暂停客户的沟通权限或者禁止客户</span>
                           <span class="decro co00">与该特定海外红人/联盟客沟通</span>
      </pre> -->

      <pre class="  co00">
           5. 免责和赔偿
      </pre>
      <pre>
                   5.1.   客户清楚并同意，平台只是提供海外红人/联盟客信息供客户沟通联系，平
                            台不保证客户通过平台获取的联系方式或通过平台的沟通工具能够及时、
                            准确联系上某特定海外红人/联盟客，不保证该海外红人/联盟客会在客户
                            所期待的期限内进行回复，也不保证客户与该海外红人/联盟客能够达成合
                            作协议。
           
                   5.2.   客户清楚并同意，平台提供的信息服务是平台基于目前现有的技术条件从
                            公开信息合法获取，由于互联网信息变化更新快，亦存在信息不全、不准
                            或错误的情况，平台并不保证其在平台上提供服务过程中给客户提供的信
                            息的100%的正确性和完整性。

                   5.3.   客户提供给平台注册的邮箱必须是自己拥有或控制的，且在收到验证码后，
                            需要妥善保管，并及时进行验证注册，不能向第三方披露，否则，由此带 
                            来的客户账号信息的泄露，给客户带来的损失由客户自己承担。

                   5.4.   客户承诺，客户将就因如下原因导致的可能致使平台被起诉、投诉或承担 
                            其他责任所引起的经济损失承担赔偿责任。

                   5.5.   其他责任所引起的经济损失承担赔偿责任。

                   5.6.   客户在履行和海外红人/联盟客达成的合作协议过程中，因任何原因导致海
                            外红人/联盟客对客户不满，从而导致海外网红起诉平台的。
        </pre>
      <!-- <pre>
                    ●     客户不履行本协议规定的义务

                    ●     客户在履行和海外红人/联盟客达成的合作协议过程中，因任何
                           原因导致海外红人/联盟客对客户不满，从而导致海外网红起诉
                           平台的。
      </pre> -->
      <pre class="  co00">
           6. 违规内容举报
      </pre>
      <pre class=" ">
            <span class="decro co00">平台再次声明，平台尽最大努力采取技术措施和组织措施，在提供给客户的</span>
            <span class="decro co00">信息或内容中，过滤或删除任何违反中华人民共和国法律法规或有损害中华</span>
            <span class="decro co00">人民共和国国家安全、政治安全或丑化、侮辱中华人民共和国国家尊严或有</span>
            <span class="decro co00">违中华人民共和国公序良俗的信息或内容（“违规内容”）。如果客户在使用</span>
            <span class="decro co00">平台的服务过程中发现有违规内容的，请客户立即停止浏览、使用或传播该</span>
            <span class="decro co00">信息，并立即向平台报告。否则，由此带来的一切责任由客户自己承担。</span>
            <span class="decro co00">户自己承担。</span>

            <span class="decro co00">平台接受处理违规信息的联系方式为：</span>

            <span class="co00 decro">邮箱：【support@foshobrands.com】</span>
      </pre>
      <pre class="  co00">
           7. 违约
      </pre>
      <pre>
                   7.1.   本协议任何一方因履行其各自在本协议项下的义务，如果一方不履行其义
                            务的，应对守约方承担违约责任
           
                   7.2.   特别地，如果客户违反了本协议项下关于不得盗用平台信息的约定的，平
                            台除有权立即终止本协议并不退还剩余服务费外，可以另行主张要求客户
                            支付违约金100万元，如果该违约金不足以弥补平台损害的，平台有权另
                            行主张索赔。    
      </pre>
      <pre class="  co00">
           8. 期限和终止
      </pre>
      <pre>
                   8.1.   本协议自成立之日起生效，有效期至双方权利义务履行完毕之日起失效。
           
                   8.2.   任何一方经提前10日通知另一方均有权解除本协议，但是，如果是客户提
                            前通知平台解除本协议的，客户支付的未消耗使用完毕的服务费用将不予
                            退还。如果客户违反本协议项下规定的义务之一的，平台有权不经通知直
                            接解除与客户之间的协议，协议解除后，客户支付的未消耗使用完毕的服
                            务费用将不予退还。

                   8.3.   客户如果不同意接受调整或修改后的本协议内容时，视为本协议终止。在
                            此情况下，客户支付的未消耗使用完毕的服务费用将由平台予以无需退还。  
      </pre>
      <pre class="co00">
           9. 法律适用和纠纷解决
      </pre>
      <pre>
                   9.1. 本协议由中华人民共和国法律管辖（冲突规则除外）。
           
                   9.2. 与本协议有关的一切纠纷和争议，如果双方无法协商解决的，由平台所在
                          地的人民法院诉讼解决。 
      </pre>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {

    }
  }
}
</script>
<style lang="less" scoped>
* {
  font-family: "OPPOSans-R";
  color: #999;
}
.Influencers {
  background: #fafafd;
  .table {
    width: 100%;
    display: flex;
    div {
      width: 20%;
      height: 50px;
      line-height: 50px;
      padding-left: 10px;
    //   color: red;
      border: 1px solid #999;
    }
    .co99 {
      color: #999;
    }
  }
  .red {
    // color: red;
  }
  pre {
    line-height: 40px;
  }
  .co00 {
    color: #000;
  }
  .decro {
    text-decoration: underline #000;
  }
  .font30 {
    font-size: 30px;
  }
  .centers {
    text-align: center;
  }
  .top {
    width: 1200px;
    margin: 0 auto;
    padding: 100px;
    font-size: 24px;
    box-sizing: border-box;
  }
}
</style>